(() => {
  function init(root) {
    root.querySelectorAll('.formthr-pf').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.formthr-pf__track');
      const cards = Array.from(track.children);
      const navigation = section.querySelector('.formthr-pf__dots');
      const dots = Array.from(navigation.children);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      navigation.hidden = false;
      const target = card => card.offsetLeft - cards[0].offsetLeft;
      const go = index => track.scrollTo({left: target(cards[index]), behavior: reduced.matches ? 'instant' : 'smooth'});
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          let index = 0;
          cards.forEach((card, i) => { if (Math.abs(target(card) - track.scrollLeft) < Math.abs(target(cards[index]) - track.scrollLeft)) index = i; });
          if (track.scrollLeft > 0 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) index = cards.length - 1;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        });
      };
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const current = dots.findIndex(dot => dot.getAttribute('aria-current') === 'true');
        go(Math.max(0, Math.min(cards.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
